import React, { FormEvent, ReactElement, useEffect, useState } from 'react';
import { Formik, FormikProps } from 'formik';
import api, { useGetQuery } from '../../../Utils/api';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { useAlertDialog } from '../../../Utils/dialogContext';
import AffichageChargement from '../Utils/AffichageChargement';
import ChampFormulaire from '../../Common/ChampFormulaire';
import CheckboxFormulaire from '../../Common/CheckboxFormulaire';
import { TitreCarte } from '../../Common/TitreCarte';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

interface PropsAffichageChargementEnfant {
    data: OptionsData;
}
export type OptionsCovid = {
    texte: string;
};
export type OptionsData = {
    texte: string;
    theme: string;
    covid: string;
    frais_annulation_base: string;
    frais_annulation_abonnement: string;
    prix_abonnement: string;
    credit_annulation: string;
};

export default function Options(): ReactElement {
    const bsAlert = useAlertDialog();
    const queryAll = useGetQuery<OptionsData>(['options/all']);

    useEffect(() => {
        document.title = 'Options - Dashboard';
    }, []);

    async function soumettreFormulaireAvis(values, { setSubmitting }): Promise<void> {
        try {
            if (values.covid.length > 0) {
                values.covid = '1';
            } else {
                values.covid = '0';
            }
            await api.post('/options', values);

            const duration = 4; // Durée en secondes
            let remainingTime = duration;

            const countdownMessage = () =>
                `Les options ont été enregistrées.
                 Rafraîchissement dans ${remainingTime} secondes.`;
            const showAlertWithCountdown = () => {
                bsAlert(countdownMessage(), 'success', 'medium', () => {
                    window.location.reload();
                });
            };
            const countdownInterval = setInterval(() => {
                remainingTime--;
                if (remainingTime >= 0) {
                    showAlertWithCountdown();
                } else {
                    clearInterval(countdownInterval);
                }
            }, 1000);

            setTimeout(() => {
                window.location.reload();
            }, duration * 1000);
        } catch (error) {
            bsAlert('Erreur avec la sauvegarde' + error, 'danger');
        } finally {
            setTimeout(() => {
                setSubmitting(false);
            }, 3000);
        }
    }

    function AffichageChargementEnfant(props: PropsAffichageChargementEnfant): ReactElement {
        return (
            <div>
                <Formik initialValues={props.data} enableReinitialize={true} onSubmit={soumettreFormulaireAvis}>
                    {FormikOptionAvis}
                </Formik>
            </div>
        );
    }

    return <AffichageChargement query={queryAll}>{AffichageChargementEnfant}</AffichageChargement>;
}

const themeAvis: string[] = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];

function FormikOptionAvis(props: FormikProps<OptionsData>): ReactElement {
    const { handleSubmit } = props;
    const queryCovid = useGetQuery<OptionsCovid>(['options/covid']);
    const [isChecked, setIsChecked] = useState(queryCovid.data?.texte === '1');
    useEffect(() => {
        if (queryCovid.data) {
            setIsChecked(queryCovid.data.texte === '1');
        }
    }, [queryCovid.data]);

    const cssTitreOptionLabel: React.CSSProperties = {
        padding: '8px 0px 0px 4px',
        fontSize: '1.2em',
    };
    const cssOptionsLabel: React.CSSProperties = {
        padding: '8px 0px 0px 24px',
    };
    function handleCheckboxChange(newValue: boolean) {
        setIsChecked(newValue);
    }

    return (
        <>
            <div className="bg-light w-100 h-100 fixed-top z-index-n1"></div>
            <Alert variant={props.values.theme}>{props.values.texte}</Alert>
            <TitreCarte>Options</TitreCarte>
            <MyPaper>
                <Form onSubmit={handleSubmit as (e: FormEvent<HTMLElement>) => void}>
                    <div style={cssTitreOptionLabel}>Avis public</div>
                    <div style={cssOptionsLabel}>
                        <ChampFormulaire estPetit labelCol={LABEL_COL} id="texte" titre="Message" />
                        <ChampFormulaire
                            estPetit
                            labelCol={LABEL_COL}
                            id="theme"
                            titre="Thème"
                            suggestions={themeAvis}
                        />
                    </div>

                    <div style={cssTitreOptionLabel}>Covid-19</div>
                    <div style={cssOptionsLabel}>
                        <Row>
                            <Col className="col-3">
                                <label>Masquer</label>
                            </Col>
                            <Col>
                                <CheckboxFormulaire
                                    id="covid"
                                    notifyChange={handleCheckboxChange}
                                    titre={'Cocher cette case pour masquer la section COVID 19 de chaque activité.'}
                                    isChecked={isChecked}
                                ></CheckboxFormulaire>
                            </Col>
                        </Row>
                    </div>
                    <div style={cssTitreOptionLabel}>Frais</div>
                    <div style={cssOptionsLabel}>
                        <Row>
                            <Col>
                                <ChampFormulaire
                                    estPetit
                                    labelCol={LABEL_COL}
                                    id="prix_abonnement"
                                    titre="Prix de l'abonnement"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ChampFormulaire
                                    estPetit
                                    labelCol={LABEL_COL}
                                    id="credit_annulation"
                                    titre="Crédit - Frais d'annulation"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ChampFormulaire
                                    estPetit
                                    labelCol={LABEL_COL}
                                    id="frais_annulation_base"
                                    titre="Frais d'annulation min. - À la carte"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ChampFormulaire
                                    estPetit
                                    labelCol={LABEL_COL}
                                    id="frais_annulation_abonnement"
                                    titre="Frais d'annulation minimum - Abonnement"
                                />
                            </Col>
                        </Row>
                    </div>

                    <Button id="submitAvis" variant="primary" type="submit">
                        Sauvegarder
                    </Button>
                </Form>
            </MyPaper>
        </>
    );
}
